<template>
  <q-field
    ref="fieldRef"
    v-bind="$attrs"
    :model-value="modelValue"
    class="time-input cursor-pointer"
    clear-icon="close"
    @clear="emit('update:modelValue', '')"
    @click="$refs.inputRef.show()"
  >
    <template
      v-if="modelValue"
      #control
    >
      {{ convertTimeFormat(modelValue) }}
    </template>
    <template #prepend>
      <q-icon
        name="img:common/icons/time.svg"
        size="24px"
      />
    </template>
    <TimeInput
      ref="inputRef"
      :model-value="modelValue"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
  </q-field>
</template>

<script setup>
import TimeInput from './TimeInput';

import useTimeFormat from '~composables/useTimeFormat';

defineOptions({
  inheritAttrs: false,
});

defineProps({
  modelValue: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue']);

const { convertTimeFormat } = useTimeFormat();

</script>
